<template>
  <div class="checkbox" :class="{ error: isError || error || $slots.error }">
    <div class="checkbox__wrapper">
      <input
        :id="c_id"
        ref="inputRef"
        class="checkbox__input visually-hidden"
        type="checkbox"
        :checked="!!value"
        :value="val"
        @change="onChange"
      />
      <span class="checkbox__square" @click="changeCheckbox">
        <Transition name="fade" mode="out-in">
          <SvgIcon v-if="!!value" name="common/checkbox-icon" class="checkbox__check" />
        </Transition>
      </span>
      <span class="checkbox__text">
        <UiText
          v-if="$slots.label || label"
          tag="label"
          font="body-text-small"
          :for="c_id"
        >
          <slot name="label">
            {{ label }}
          </slot>
        </UiText>
        <UiText
          v-if="$slots.error || error"
          font="body-caption"
          class="checkbox__error"
        >
          <slot name="error" />
          {{ error }}
        </UiText>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiCheckbox',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: { default: false }, // used as checked prop, value here for v-model.
    // eslint-disable-next-line vue/require-prop-types
    valueTrue: { default: true },
    // eslint-disable-next-line vue/require-prop-types
    valueFalse: { default: false },
    val: { type: [Boolean, Number, String] },
    label: { type: String },
    id: { type: [String, Number], required: false }, // don't need id by default, have uId
    error: { type: String },
    isError: { type: Boolean },
  },
  data() {
    return {
      uId: null,
    }
  },
  computed: {
    c_id() {
      return this.id ?? this.uId
    },
  },
  async created() {
    this.uId = await this.$store.dispatch('base/getUid')
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.checked ? this.valueTrue : this.valueFalse)
      this.$emit(e.target.checked ? 'true' : 'false')
    },
    changeCheckbox() {
      this.$refs.inputRef.click()
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped />
